module.exports = "/_next/static/images/5ff37b8022dcc7f08c8b75b6bb0cf118-icon-monthly-payments-new.svg";